import { Component } from '@angular/core';

@Component({
  selector: 'app-nft-template',
  templateUrl: './nft-template.component.html',
  styleUrls: ['./nft-template.component.scss']
})
export class NftTemplateComponent {

}
